module.exports = __webpack_public_path__ + "static/media/document-ic.dfd3390e.svg";